export default __webpack_public_path__ + "static/media/instagramIcon.e5adfa9e.svg";